export default function({ route, req,  res }) {
  // 只在服务端执行
  if (process.server && res) {
    const userAgent = (req.headers['user-agent'] || '').toLowerCase()

    const crawlerKeywords = [
      'spider', 'bot', 'crawler', 'scraper', 'wget', 'curl',
      'python-requests', 'scrapy', 'phantomjs', 'headlesschrome'
    ]

    const isCrawler = crawlerKeywords.some(keyword => userAgent.includes(keyword))
    const isEmptyUA = !userAgent || userAgent.length < 10
    const isProtectedPath = route.path.endsWith('.html')

    if ((isCrawler || isEmptyUA) && isProtectedPath) {
      console.warn('[Anti-Crawler] Blocked:', userAgent)
      res.writeHead(302, { Location: '/404' })
      res.end()

    }
  }
}
